import { postToggle } from "features/social-toggles/data/utils";
import { useUser } from "hooks/useUser";
import React, { useEffect, useState } from "react";
import ToggleButton from "ui/ToggleButton";

import type { SocialToggleProps } from "./SocialToggle.types";
import { kindConfig } from "./SocialToggle.utils";

const SocialToggle: React.FC<SocialToggleProps> = ({
  count = 0,
  objectType,
  objectId,
  toggledByUser = false,
  kind = "like",
  disabled = false,
  onToggle,
  onOppositeToggle,
}) => {
  const { isLoggedIn } = useUser();
  const [toggled, setToggled] = useState(toggledByUser);
  const [toggledCount, setToggledCount] = useState(count);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setToggled(toggledByUser);
  }, [toggledByUser]);
  useEffect(() => {
    setToggledCount(count);
  }, [count]);

  const config = kindConfig[kind];

  const handleToggle = async () => {
    if (!objectType || !objectId || isLoading) return;
    setIsLoading(true);
    try {
      const data = await postToggle(config.url, {
        content_type: objectType,
        id: objectId,
      });
      setToggled((data?.[config.toggledKey] as boolean) ?? false);
      setToggledCount((data?.[config.countKey] as number) ?? 0);

      const oppositeConfig = config.oppositeKind
        ? kindConfig[config.oppositeKind]
        : undefined;

      if (oppositeConfig && data?.[oppositeConfig.toggledKey] !== undefined) {
        onOppositeToggle?.(
          data[oppositeConfig.toggledKey] as boolean,
          data[oppositeConfig.countKey] as number,
        );
      }

      onToggle?.(data);
    } catch (error) {
      console.error(`Error toggling ${kind}:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isLoggedIn) return null;

  return (
    <ToggleButton
      symbol={config.symbol}
      count={toggledCount}
      toggled={toggled}
      loading={isLoading}
      onClick={handleToggle}
      disabled={disabled || !objectType || !objectId}
    />
  );
};

export default SocialToggle;
